import React from "react";

export default function ReportCloseModal({ report, response, setResponse, onClose, onSubmit }) {
	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
			<div className="bg-white rounded-lg shadow-lg p-6 w-[500px]">
				<h2 className="text-lg font-bold mb-4 text-center">
					Risolvi la segnalazione #{report.id}
				</h2>
				<p className="text-gray-700 mb-4">{report.text}</p>
				<textarea
					className="w-full border border-gray-300 rounded p-2 mb-4"
					placeholder="Scrivi la tua risposta per l'utente"
					value={response}
					onChange={(e) => setResponse(e.target.value)}
				/>
				<div className="flex justify-end space-x-2">
					<button
						className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
						onClick={onClose}
					>
						Annulla
					</button>
					<button
						className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
						onClick={() => onSubmit(false)}
					>
						Risolvi senza risposta
					</button>
					<button
						className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
						onClick={() => onSubmit(true)}
					>
						Invia risposta
					</button>
				</div>
			</div>
		</div>
	);
}
